import { 
    Pipe, 
    PipeTransform 
}                                   from "@angular/core";

import { CtmTranslateService }      from "../services";

@Pipe({
    name: "translate",
    pure: false // impure pipe, update value when we change language
})

export class CtmTranslatePipe implements PipeTransform {
    constructor(
        private translate: CtmTranslateService
    ) { 
        
    }

    transform(value: string, module: string): any {
        if (!value) return;

        return this.translate.instant(value, module);
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/pipes/translate.pipe.ts